export default __webpack_public_path__ + "static/ai-marketing-8-eb3aede6a3016295255f2c80d834758b.png";